import { Hero } from '../../components/Hero';
import { useContext } from 'react';
import { ThemeContext } from '../../components/ThemeContext';
import { AccordionBlok } from '../../components/AccordionBlok';
import { Companies } from '../../components/Companies';
import { References } from '../../components/References';
import { TabsComponent } from '../../components/TabStepper';

export const Root = () => {

    const [theme] = useContext(ThemeContext) as ["light" | "dark", React.Dispatch<React.SetStateAction<"light" | "dark">>];

    return (
        <div className={theme}>
            <Hero />
            <Companies />
            <TabsComponent />
            <References />
            <AccordionBlok />
        </div>
    );
};
  